<template>
	<div class="max-w-6xl mx-auto grid grid-cols-12 gap-6 mt-8 mb-20">
		<carga-tabs></carga-tabs>
	</div>
</template>
<script>
	import CargaTabs from "@/components/CargaTabs";
	
	export default {
		components: {
			CargaTabs,
		},
		data(){
			return {
			}
		},
		methods:{
		}
	}
</script>